import { render } from "./Variant_Table.vue?vue&type=template&id=5325da31"
import script from "./Variant_Table.vue?vue&type=script&lang=js"
export * from "./Variant_Table.vue?vue&type=script&lang=js"

import "./Variant_Table.vue?vue&type=style&index=0&id=5325da31&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__